<template>
  <div class="sidebar-left" :class="[SIDE_MENU == 1 ? 'opensidebar':'closesidebar' ]">
    <ToolbarIcon/>
    <div class="sidebar-body scroll-pane">
      <div class="side-nav">
        <div
          v-for="(menuItems, index) in menu"
          :key="index"
          class="menu-group"
        >
          <router-link
            v-for="(item, index1) in menuItems"
            :key="index1"
            :to="item.route"
            class="menu-item"
            @click.native="Toggle"
          >
            <font-awesome-icon :icon="item.icon" class="icon menu-icon" /> <span class="ml-3 menu-text">{{ $t(item.title) }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import {mapActions, mapGetters} from "vuex";
  import ToolbarIcon from "./ToolbarIcon";

export default {
  components: {ToolbarIcon},
  data () {
    return {
      sidebar: 'sidebar',
      menu: [

        [
          {
            title: 'navigation.dashboard',
            icon: 'tachometer-alt',
            route: '/supplier/dashboard'
          },
          {
            title: 'navigation.customers',
            icon: 'user',
            route: '/supplier/customers'
          },
          {
            title: 'navigation.items',
            icon: 'star',
            route: '/supplier/items'
          }
        ],

        [
          {
            title: 'navigation.pos',
            icon: 'file',
            route: '/supplier/purchase-orders'
          },
          {
            title: 'navigation.deliveryNotes',
            icon: 'shipping-fast',
            route: '/supplier/delivery-notes'
          },
          {
            title: 'navigation.invoices',
            icon: 'file-alt',
            route: '/supplier/invoices'
          },
          {
            title: 'navigation.payments',
            icon: 'credit-card',
            route: '/supplier/payments'
          },
          {
            title: 'navigation.preapproved_invoices',
            icon: 'file-invoice',
            route: '/supplier/preapproved-invoices'
          }

          // {
          //   title: 'navigation.expenses',
          //   icon: 'space-shuttle',
          //   route: '/supplier/expenses'
          // }
        ],
        [
          {
            title: 'navigation.reports',
            icon: 'signal',
            route: '/supplier/reports'
          },
          {
            title: 'navigation.data_exports',
            icon: 'file-export',
            route: '/supplier/data-exports'
          }
        ],
        [
          {
            title: 'navigation.tijarah_financing',
            icon: 'shopping-bag',
            route: '/supplier/funders'
          }
        ],
        [
          {
            title: 'navigation.profile',
            icon: 'cogs',
            route: '/supplier/profile'
          },
          {
            title: 'navigation.settings',
            icon: 'cog',
            route: '/supplier/settings'
          },
          {
            title: 'navigation.user_guides',
            icon: 'file-pdf',
            route: '/supplier/user-guides'
          }

        ]

      ]
    }
  },

  computed: {
    ...mapGetters('general', [
      'SIDE_MENU'
    ]),
  },
  created () {
    if (localStorage.getItem('role') === 'admin') {
      this.menu.splice(3, 0, [
        {
          title: 'navigation.user_management',
          icon: 'users-cog',
          route: '/supplier/user-managements'
        }
      ])
    }
  },
  methods: {
    Toggle () {
      this.$utils.toggleSidebar()
    },
  }
}
</script>
